import { FC } from "react";

import { ShopTeaser as UIShopTeaser } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/ShopTeaser/ShopTeaser";

import { ShopTeaserProps } from "./ShopTeaser.builder";

export const ShopTeaser: FC<ShopTeaserProps> = ({
  topText,
  theme,
  ...props
}) => {
  // change topText to bottomText once content migration is possible through migration scripts
  return <UIShopTeaser theme={theme} {...props} bottomText={topText} />;
};
